import * as React from 'react';
import styled, { css } from 'styled-components';
import { getWidth } from '@components/styles';
import { rgba } from 'polished';

export interface SidebarWrapperProps {
  className?: string;
  children?: any;
  hasScoll?: boolean;
}

export const SidebarWrapper: React.FC<SidebarWrapperProps> = (props) => (
  <div className={props.className}>
    <div className="wrapper">{props.children}</div>
  </div>
);

export default styled(SidebarWrapper)`
  display: none;

  --top: 160px;
  --pad-block-end: 24px;

  @media ${({ theme }) => theme.device.tablet} {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: ${getWidth(5)};

    .wrapper {
      position: sticky;
      top: var(--top);

      ${({ hasScoll }) =>
        hasScoll &&
        css`
          max-height: calc(100vh - var(--top) - var(--pad-block-end));
          overflow-y: scroll;
          padding-block-end: var(--pad-block-end);

          ::-webkit-scrollbar {
            width: 12px;
          }

          ::-webkit-scrollbar-track {
            background: transparent;
          }

          ::-webkit-scrollbar-thumb {
            background-color: ${({ theme }) =>
              rgba(theme.colors.primary, 0.15)};
            border-radius: 8px;
            border: 4px solid ${({ theme }) => theme.colors.differentBackground};
          }
        `}
    }
  }
`;
